import { Injectable } from '@angular/core';
import { ActionTypes } from './ngrx-store.actions';
import { AsyncSubject, Observable } from 'rxjs';
import { StoreKey } from './ngrx-store.keys';
import { Store } from '@ngrx/store';
export const StoreKeys = StoreKey;

@Injectable({
    providedIn: 'root'
})
export class StoreService {
    constructor(private store: Store<{ state: any }>) { }

    Get(id: StoreKey): Observable<any> {
        const subject = new AsyncSubject();
        this.getValueById(id).subscribe(data => {
            subject.next(data);
        });
        subject.complete();
        return subject;
    }

    GetMany(ids: StoreKey[]): Observable<any> {
        const returnData: any = {};
        const subject = new AsyncSubject();
        for (const id of ids) {
            this.getValueById(id).subscribe(data => returnData[StoreKey[id]] = data);
        }
        subject.next(returnData);
        subject.complete();
        return subject;
    }

    Save(id: StoreKey, data: any, isAppLevel?: boolean) {
        const payload: any = {};
        payload[StoreKey[id]] = { data, isAppLevel: isAppLevel ? isAppLevel : false };
        this.store.dispatch({ type: ActionTypes.save.toString(), payload });
    }

    private getValueById(id: StoreKey): Observable<any> {
        const subject = new AsyncSubject();
        this.store.select((s: any) => s.state[StoreKey[id]])
            .subscribe((state: any) => {
                if (state) {
                    const data = state.data;
                    subject.next(data);
                    subject.complete();
                    if (state.isAppLevel === false) {
                        this.store.dispatch({ type: ActionTypes.delete.toString(), payload: StoreKey[id] });
                    }
                } else {
                    subject.complete();
                }
            }).unsubscribe();
        return subject;
    }
}
